import styled from "styled-components";
import { BASIC_ORANGE } from "../../../constants/colors";

type Props = {
  price: number;
  priceWithTax: number;
  isOriginalPrice?: boolean;
  isDiscountPrice?: boolean;
  size: "md" | "lg";
};

export const MenuPrice: React.FC<Props> = ({
  price,
  priceWithTax,
  isOriginalPrice,
  isDiscountPrice,
  size,
}) => {
  return (
    <MenuPriceText
      $strikeThrough={isOriginalPrice}
      $discount={isDiscountPrice}
      $size={size}
    >
      税込
      <PriceWithTaxText $size={size}>
        ¥{priceWithTax.toLocaleString()}
      </PriceWithTaxText>{" "}
      <PriceText $size={size}>(¥{price.toLocaleString()})</PriceText>
    </MenuPriceText>
  );
};

const MenuPriceText = styled.div<{
  $strikeThrough?: boolean;
  $discount?: boolean;
  $size?: "md" | "lg";
}>`
  font-size: ${({ $size }) => ($size === "md" ? "12px" : "16px")};
  font-weight: 600;
  ${({ $strikeThrough }) => $strikeThrough && "text-decoration: line-through;"}
  ${({ $discount }) => $discount && `color: ${BASIC_ORANGE};`}
`;

const PriceWithTaxText = styled.span<{
  $size?: "md" | "lg";
}>`
  font-size: ${({ $size }) => ($size === "md" ? "16px" : "20px")};
  font-weight: 600;
`;

const PriceText = styled.span<{
  $size?: "md" | "lg";
}>`
  font-size: ${({ $size }) => ($size === "md" ? "12px" : "16px")};
  font-weight: 500;
  margin-left: 9px;
`;
